<script lang="ts">
	import 'normalize.css';
	import { Router, Route } from 'svelte-routing';
	import Drawer, { AppContent, Content, Header, Scrim } from '@smui/drawer/styled';
	import { FixedAdjust } from '@smui/top-app-bar/styled';
	import List from '@smui/list/styled';
	import {
		Dashboard,
		NewPersona,
		LoggedUserRouter,
		Linkify,
		InterestTable,
		NewLogin,
		AuthCallback,
		Preferences,
		PersonaExplorer,
		MixPersona,
		CombineDashboard,
		InterestOverlap,
		DuplicatePersona,
		Users,
		UsersAdd,
		UsersChange,
		LookalikeModel
	} from './routes';
	import ApiConnector from './containers/ApiConnector.svelte';
	import TopAppBar from './containers/TopAppBar.svelte';
	import { APP_PATHS } from './constants';
	import NavLink from './components/NavLink.svelte';
	import Navigate from './components/Navigate.svelte';
	import ClientTheme from './containers/ClientSpecific/ClientTheme.svelte';
	import ClientLogo from './containers/ClientSpecific/ClientLogo.svelte';
	import { userInfo } from './stores';
	import LookalikeModelCreate from './routes/LookalikeModel/LookalikeModelCreate.svelte';
	import LookalikeModelDetail from './routes/LookalikeModel/LookalikeModelDetail.svelte';
	import Text from './components/Text.svelte';
	export let url = '';
	let drawer: Drawer;
	let drawerOpen = false;
	const toggleDrawer = () => (drawerOpen = !drawerOpen);
	const isDevEnv = window.location.hostname === 'dev.app.adpicker.ai';
	let isClientDentsuCZ = false;
	$: {
		if ($userInfo.client !== undefined) {
			isClientDentsuCZ = $userInfo.client.id === '1' || $userInfo.client.id === '7';
		}
	}
</script>

<Router {url}>
	<ClientTheme>
		<ApiConnector>
			<LoggedUserRouter>
				<TopAppBar on:menuclick={toggleDrawer} />
				<Drawer variant="modal" bind:this={drawer} bind:open={drawerOpen}>
					<Header>
						<ClientLogo />
					</Header>
					<nav class="nav">
						<Content>
							<List>
								<NavLink graphic="dashboard" to={APP_PATHS.DASHBOARD} on:click={toggleDrawer}>
									Dashboard
								</NavLink>
								<NavLink graphic="group_add" to={APP_PATHS.ADD_PERSONA} on:click={toggleDrawer}>
									Add Persona
								</NavLink>
								<NavLink
									graphic="view_agenda"
									to={APP_PATHS.COMBINE_DASHBOARD}
									on:click={toggleDrawer}
								>
									Combined dashboard
								</NavLink>
								<NavLink graphic="build" to={APP_PATHS.MIX_PERSONA} on:click={toggleDrawer}>
									Mix persona
								</NavLink>
								<NavLink graphic="nature_people" to={APP_PATHS.LINKIFY} on:click={toggleDrawer}>
									Keyword targeting
								</NavLink>
								<NavLink
									graphic="attribution"
									to={APP_PATHS.LOOKALIKE_MODEL}
									on:click={toggleDrawer}
								>
									Lookalike Targeting
								</NavLink>
								{#if isDevEnv}
									<NavLink graphic="toc" to={APP_PATHS.INTERESTS_TABLE} on:click={toggleDrawer}>
										Persona Interests
									</NavLink>
									<NavLink
										graphic="explore"
										to={APP_PATHS.PERSONA_EXPLORER}
										on:click={toggleDrawer}
									>
										Persona Explorer
									</NavLink>
								{/if}
								<NavLink graphic="list_alt" to={APP_PATHS.INTEREST_OVERLAP} on:click={toggleDrawer}>
									Interest Overlap
								</NavLink>
							</List>
							<List>
								<Text><div style="margin-left: 20px">App version: <strong>1.1</strong></div></Text>
								<NavLink graphic="settings" to={APP_PATHS.PREFERENCES} on:click={toggleDrawer}>
									Settings
								</NavLink>
							</List>
						</Content>
					</nav>
				</Drawer>

				<Scrim />
				<AppContent>
					<main use:FixedAdjust>
						<Route path={APP_PATHS.INTERESTS_TABLE} component={InterestTable} />
						<Route path={APP_PATHS.INTEREST_OVERLAP} component={InterestOverlap} />
						<Route path={APP_PATHS.LINKIFY} component={Linkify} />
						<Route
							path={APP_PATHS.ADD_PERSONA}
							component={NewPersona}
							isDentsu={isClientDentsuCZ}
						/>
						<Route path={APP_PATHS.MIX_PERSONA} component={MixPersona} />
						<Route path={APP_PATHS.COMBINE_DASHBOARD} component={CombineDashboard} />
						<Route path={APP_PATHS.DASHBOARD} component={Dashboard} />
						<Route path={APP_PATHS.PREFERENCES} component={Preferences} />
						<Route path={APP_PATHS.PERSONA_EXPLORER} component={PersonaExplorer} />
						<Route path={APP_PATHS.DUPLICATE_PERSONA} let:params>
							<DuplicatePersona id={params.id} />
						</Route>
						<Route path={APP_PATHS.USER_MANAGEMENT} component={Users} />
						<Route path={APP_PATHS.USER_MANAGEMENT_ADD} component={UsersAdd} />
						<Route path={APP_PATHS.USER_MANAGEMENT_CHANGE} let:params>
							<UsersChange email={params.email} role={params.role} />
						</Route>
						<Route path={APP_PATHS.LOOKALIKE_MODEL} component={LookalikeModel} />
						<Route path={APP_PATHS.LOOKALIKE_MODEL_CREATE} component={LookalikeModelCreate} />
						<Route path={APP_PATHS.LOOKALIKE_MODEL_DETAIL} let:params>
							<LookalikeModelDetail id={params.id} />
						</Route>
						<Route>
							<Navigate path={'/'} />
						</Route>
					</main>
				</AppContent>
				<div class="login-wrap" slot="notlogged">
					<Route path={APP_PATHS.LOGIN} component={NewLogin} />
					<Route path={`${APP_PATHS.LOGIN_CALLBACK}/:authProvider`} component={AuthCallback} />
					<Route>
						<Navigate path={APP_PATHS.LOGIN} />
					</Route>
				</div>
			</LoggedUserRouter>
		</ApiConnector>
	</ClientTheme>
</Router>

<style>
	.login-wrap {
		height: 100%;
		display: flex;
		justify-content: space-around;
		align-items: center;
		background: white;
	}
	.nav {
		flex: 1;
		justify-content: space-between;
	}
	.nav :global(.mdc-list-item) {
		margin: 0;
		border-radius: 0;
		padding: 0 16px;
	}
	.nav :global(.mdc-drawer__content) {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
</style>
